import { MobileTable, MobileTableProps } from 'components/@shared/TableRemotePagination/MobileTable/MobileTable';
import {
    TableRemotePagination,
    TableRemotePaginationProps,
} from 'components/@shared/TableRemotePagination/TableRemotePagination';
import { useWindowSize } from 'hooks/useWindowSize';
import { useMemo } from 'react';

type Props<T> = MobileTableProps<T> &
    TableRemotePaginationProps<T> & {
        hideMobileView?: boolean;
    };

export const AdaptiveTable = <T extends { id: string }>({ hideMobileView, ...props }: Props<T>) => {
    const [width] = useWindowSize();

    const isTablet = useMemo(() => width !== 0 && width < 1024, [width]);

    if (isTablet && !hideMobileView) {
        return <MobileTable {...props} />;
    }
    return <TableRemotePagination {...props} />;
};
